export const apiResponseMessage = {
  suspendFailed: "Failed to suspend user. Please try again later.",
  deletedFailed: "Failed to delete user. Please try again later.",
  tryAging: "Please try again or contact support if the issue persists.",
};
